document.addEventListener("DOMContentLoaded", function () {
  const ranges = document.querySelectorAll(".js-range-bar");
  if (!ranges.length) {
    return;
  }

  function init(wrap) {
    const minRange = wrap.querySelector(".js-range-bar-min");
    const maxRange = wrap.querySelector(".js-range-bar-max");
    const fill = wrap.querySelector(".js-range-bar-fill");

    const minLabel = wrap.querySelector(".js-range-bar-min-label");
    const maxLabel = wrap.querySelector(".js-range-bar-max-label");

    const minInput = wrap.querySelector(".js-range-bar-min-input");
    const maxInput = wrap.querySelector(".js-range-bar-max-input");

    const outMin = wrap.querySelector(".js-range-bar-out-min");
    const outMax = wrap.querySelector(".js-range-bar-out-max");

    const resetBtn = wrap.querySelector(".js-range-bar-reset");

    if (!minRange || !maxRange || !fill) {
      return;
    }

    wrap.dataset.ready = "0";

    const MIN = Number(wrap.dataset.min || 0);
    const MAX = Number(wrap.dataset.max || 1000);
    const STEP = Number(wrap.dataset.step || 1);
    const GAP = Number(wrap.dataset.gap || 0);
    const field = (wrap.dataset.field || "price").toLowerCase();
    const format = (wrap.dataset.format || "").toLowerCase();
    const isHourLikeField = field.includes("start") || field.includes("duration");

    function fmt(n) {
      if (isHourLikeField) {
        return `${n}h`;
      }

      if (format === "number") {
        return String(n);
      }

      return new Intl.NumberFormat("es-ES", {
        style: "currency",
        currency: "EUR",
        maximumFractionDigits: 0,
      }).format(n);
    }

    for (const el of [minRange, maxRange]) {
      el.min = MIN;
      el.max = MAX;
      el.step = STEP;
    }

    minRange.value = MIN;
    maxRange.value = MAX;

    minRange.style.zIndex = 3;
    maxRange.style.zIndex = 2;

    function clamp() {
      let minV = Number(minRange.value);
      let maxV = Number(maxRange.value);

      if (minV > maxV - GAP) minV = maxV - GAP;
      if (maxV < minV + GAP) maxV = minV + GAP;

      minV = Math.max(MIN, Math.min(minV, MAX));
      maxV = Math.max(MIN, Math.min(maxV, MAX));

      minRange.value = minV;
      maxRange.value = maxV;

      return { minV, maxV };
    }

    function updateFill(minV, maxV) {
      const minPct = ((minV - MIN) / (MAX - MIN)) * 100;
      const maxPct = ((maxV - MIN) / (MAX - MIN)) * 100;

      fill.style.left = minPct + "%";
      fill.style.right = 100 - maxPct + "%";
    }

    function updateUI() {
      const { minV, maxV } = clamp();

      if (minLabel) minLabel.textContent = fmt(minV);
      if (maxLabel) maxLabel.textContent = fmt(maxV);

      if (minInput) minInput.value = minV;
      if (maxInput) maxInput.value = maxV;

      if (outMin) outMin.textContent = minV;
      if (outMax) outMax.textContent = maxV;

      updateFill(minV, maxV);
      wrap.dataset.ready = "1";

      const evt = new CustomEvent("range-bar:change", {
        bubbles: true,
        detail: { field: field, min: minV, max: maxV },
      });
      wrap.dispatchEvent(evt);
    }

    function setZ(e) {
      if (e.target === minRange) {
        minRange.style.zIndex = 3;
        maxRange.style.zIndex = 2;
      } else {
        maxRange.style.zIndex = 3;
        minRange.style.zIndex = 2;
      }
    }

    minRange.addEventListener("input", (e) => {
      setZ(e);
      updateUI();
    });
    maxRange.addEventListener("input", (e) => {
      setZ(e);
      updateUI();
    });

    if (minInput) {
      minInput.addEventListener("change", () => {
        const v = minInput.value === "" ? MIN : Number(minInput.value);
        minRange.value = v;
        updateUI();
      });
    }

    if (maxInput) {
      maxInput.addEventListener("change", () => {
        const v = maxInput.value === "" ? MAX : Number(maxInput.value);
        maxRange.value = v;
        updateUI();
      });
    }

    if (resetBtn) {
      resetBtn.addEventListener("click", () => {
        minRange.value = MIN;
        maxRange.value = MAX;
        minRange.style.zIndex = 3;
        maxRange.style.zIndex = 2;
        updateUI();
      });
    }

    updateUI();
  }

  ranges.forEach(init);
});
